"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentsStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class PaymentsStore {
    constructor() {
        this.loading = false;
        this.error = "";
        this.tokenizedCard = {}; //D-002
        this.createPayment = async (submission) => {
            const result = await api_1.PaymentEndpoint.createPayment.apiCall(null, { submission });
            if (api_1.isError(result)) {
                return { success: false, error: result.code };
            }
            return { success: true };
        };
        // D-002
        this.createCardPayment = async (cardSubmission) => {
            const result = await api_1.PaymentEndpoint.createCardPayment.apiCall(null, { cardSubmission });
            if (api_1.isError(result)) {
                return {
                    success: false,
                    error: result.code,
                    message: result.errProp || result.code,
                    data: result
                };
            }
            return { success: true, data: result };
        };
        // D-002.840 Phase 2
        this.refundCardPayment = async (paymentId, idempotencyKey) => {
            const result = await api_1.PaymentEndpoint.refundCardPayment.apiCall(null, {
                paymentId,
                idempotencyKey
            });
            if (api_1.isError(result)) {
                return {
                    success: false,
                    error: result.code,
                    message: result.errProp || result.code
                };
            }
            return { success: true, data: result };
        };
        this.deletePayment = async (paymentId) => {
            const query = { paymentId };
            const result = await api_1.PaymentEndpoint.deletePayment.apiCall({ query });
            if (!api_1.isError(result)) {
                return { success: true };
            }
            return { success: false, error: "Unable to delete entry." };
        };
        this.readPayments = async (orderId) => {
            const query = { orderId };
            const result = await api_1.PaymentEndpoint.readPayments.apiCall({ query });
            if (!api_1.isError(result)) {
                return result.payments;
            }
        };
        // D-002.58
        this.readPaymentsBySite = async (siteId) => {
            const query = { siteId };
            const result = await api_1.PaymentEndpoint.readPaymentsBySite.apiCall({ query });
            if (!api_1.isError(result)) {
                return result.payments;
            }
            this.paymentArr = result;
        };
        // D-002.53
        this.readProfileByPatient = async (patientId, siteId) => {
            const query = { patientId, siteId };
            const result = await api_1.PaymentEndpoint.readProfileByPatient.apiCall({ query });
            if (!api_1.isError(result)) {
                return result.patProfile;
            }
            return result;
        };
        this.deleteSavedCard = async (profileRecordId, orderId) => {
            const result = await api_1.PaymentEndpoint.deleteSavedCard.apiCall(null, {
                profileRecordId,
                orderId
            });
            if (api_1.isError(result)) {
                return {
                    success: false,
                    error: result.code,
                    message: result.errProp || result.code
                };
            }
            return { success: true };
        };
        // D-002.611 initaiate a mailer for pdf attchement
        this.sendPaymentReceipt = async (obj) => {
            const result = await api_1.PaymentEndpoint.sendPaymentReceipt.apiCall(null, { obj });
            if (!api_1.isError(result)) {
                return result;
            }
        };
        // D-002 Phase 3 — Hosted iFrame Tokenizer config
        this.readCcTokenizerConfig = async () => {
            const result = await api_1.PaymentEndpoint.readCcTokenizerConfig.apiCall(null, {});
            if (api_1.isError(result)) {
                return null;
            }
            return {
                iframeUrl: result.iframeUrl || ""
            };
        };
    }
}
__decorate([
    mobx_1.observable
], PaymentsStore.prototype, "loading", void 0);
__decorate([
    mobx_1.observable
], PaymentsStore.prototype, "error", void 0);
__decorate([
    mobx_1.observable
], PaymentsStore.prototype, "tokenizedCard", void 0);
__decorate([
    mobx_1.observable
], PaymentsStore.prototype, "paymentArr", void 0);
exports.paymentsStore = new PaymentsStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/tabs/payment/store.ts
// module id = 2441
// module chunks = 0 1